import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { ServiceFeedback } from "../../types/service.type";
import { formatLocalizedTimeAgo } from "../../../../utils/formatDate";

const bodyStyles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  serviceName: {
    color: "var(--Gray-900, #101828)",
    fontFamily: "Montserrat",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "28px",
  },
  timeAgo: {
    fontFamily: "Montserrat",
    color: "#9095A0",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "18px",
  },
  comment: (isFullHeight: boolean) => ({
    fontFamily: "Montserrat",
    color: "var(--Gray-600, #475467)",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px",
    minHeight: isFullHeight ? "192px" : "auto",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 8,
    WebkitBoxOrient: "vertical",
  }),
};

const ServiceFeedbackCardBody = ({
  feedback,
  isFullHeight = true,
}: {
  feedback: ServiceFeedback;
  isFullHeight?: boolean;
}) => {
  const { i18n } = useTranslation();
  const { service, comment, createdAt } = feedback;

  const serviceName = service?.name;

  const timeAgo = formatLocalizedTimeAgo(createdAt, i18n.language);

  return (
    <Box sx={bodyStyles.container}>
      <Box sx={bodyStyles.headerContainer}>
        {serviceName && <Typography sx={bodyStyles.serviceName}>{serviceName}</Typography>}
        <Typography sx={bodyStyles.timeAgo}>{timeAgo}</Typography>
      </Box>
      <Typography sx={bodyStyles.comment(isFullHeight)}>{comment}</Typography>
    </Box>
  );
};

export default ServiceFeedbackCardBody;
